import { useMemo } from "react"
import { Link } from "react-router"
import { ProtectedRoute } from "@/lib/auth/protected-route"
import { AppLayout } from "@/components/layout/app-layout"
import { Roles } from "@/lib/team/roles"
import { useAuth } from "@/lib/auth/auth-context"
import { useOrganization } from "@/lib/organization/organization-context"
import { useEstimates } from "@/lib/api/use-estimates"
import { useTeam, useTeamMembers } from "@/lib/api/use-teams"
import { WalletView } from "@/components/wallet/wallet-view"

// Service-advisor wallet — separate surface from the dashboard so
// transactions, pending balance, payout history, and (later) cash-out
// flows have room to breathe. Visual grammar borrows from Revolut: hero
// balance card, generous whitespace, date-bucketed transactions, restrained
// color (emerald for credits, zinc for everything else).

export default function WalletPage() {
  const { user } = useAuth()
  const { activeTeamId } = useOrganization()
  const { data: team } = useTeam(activeTeamId)
  const { data: members } = useTeamMembers(activeTeamId ? Number(activeTeamId) : null)
  const { data: estimates } = useEstimates(activeTeamId)

  const firstName = user?.firstName?.trim() || "there"
  const advisorCount = useMemo(
    () => (members ?? []).filter((m) => m.role === Roles.ServiceAdvisor).length,
    [members],
  )

  return (
    <ProtectedRoute>
      <AppLayout>
        <WalletView
          team={team}
          estimates={estimates ?? []}
          members={members}
          firstName={firstName}
          currentUserId={user?.id ? Number(user.id) : null}
          activeAdvisorCount={advisorCount}
          backHref="/dashboard"
        />
        {/* Tiny secondary nav for desktop — mobile uses the AppLayout's
            existing back chrome. */}
        <div className="hidden md:block fixed top-4 left-4 z-30">
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-1 h-9 px-3 rounded-xl border border-zinc-200 bg-white/80 backdrop-blur text-[12.5px] font-semibold text-zinc-700 hover:bg-white"
          >
            ← Back
          </Link>
        </div>
      </AppLayout>
    </ProtectedRoute>
  )
}
